















/* Created- 01 - Oct - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { warn } from "vue-class-component/lib/util";
@Component(
	{
		name: "ParticaRightDrawer"
	})
export default class ParticaRightDrawer extends Vue {
	@Prop({ default: 600 }) private width: number;
	@Prop() private value: boolean;
	private display: boolean = false;
	@Watch("value")
	private watcher() {
		this.display = this.value;
	}
	@Watch("display")
	private update() {
		this.$emit("input", this.display);
	}

	private mounted() {
		this.display = this.value;
	}
}
